import { z } from 'zod';

/**
 * NEX-1645 (plan 2026-10-20, Tareas 3.1 y 3.4) — `GET /app/features`, public (no auth), mounted by
 * nexvia-api-web next to `GET /app/version-check` (`src/modules/app-config/app-config.routes.ts`).
 * Wrapped: `{ success: true, data: { storage: "off" | "registration_only" | "full" } }`.
 *
 * The API derives `storage` from two flags the backoffice sets (`storage_module_enabled`,
 * `storage_client_requests_enabled` — its `domain/storage-module-state.ts`):
 * - `off`: the module is hidden for clients and depósitos (the API answers 503
 *   `STORAGE_MODULE_DISABLED` to the depósito routes);
 * - `registration_only`: depósitos register and set up their account, clients cannot request a
 *   guardado yet, so nothing is quoted (503 `STORAGE_REQUESTS_DISABLED` on the quote);
 * - `full`: everything is on.
 *
 * Unknown keys in `data` are stripped (a future flag does not break this parse); an unknown
 * `storage` value fails it, and the caller reads a failed read as `full` (`useStorageModuleState`).
 */
export const StorageModuleStateSchema = z.enum(['off', 'registration_only', 'full']);
export type StorageModuleState = z.infer<typeof StorageModuleStateSchema>;

export const AppFeaturesResponseSchema = z.object({
  success: z.literal(true),
  data: z.object({ storage: StorageModuleStateSchema })
});
